module.exports = __webpack_public_path__ + "static/pipp-header-logo-be6b34db5fe316d060ea0346a511a53b.svg";